<template>
  <div class="checkbox-item" :class="{ checked }" @click="onToggle">
    <div class="left">
      <input
        class="native-checkbox"
        type="checkbox"
        :id="id"
        :checked="checked"
        @change.stop="onToggle"
      />
      <span class="fake-box" :class="{ checked }"></span>
    </div>

    <div class="center">
      <div class="label">{{ label }}</div>
    </div>

    <div class="right">
      <div class="right-display">{{ rightDisplayInfo }}</div>
      <button
        class="info-toggle"
        type="button"
        :aria-expanded="checked"
        @click.stop.prevent="$emit('toggle')"
        :style="{ visibility: expandable && hasDetails ? 'visible' : 'hidden' }"
      >
        <span class="caret" :class="{ open: checked }"></span>
      </button>
    </div>

    <div class="info-row" v-if="(expandable && checked) || (!expandable && hasDetails)">
      <transition name="fade-slide" v-if="expandable">
        <div v-show="checked" class="info" @click.stop>
          <slot name="details" :details="detailedInfo" />
        </div>
      </transition>

      <div v-else-if="hasDetails" class="info" @click.stop>
        <slot name="details" :details="detailedInfo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxItem',
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    rightDisplayInfo: { type: [String, Number], default: '' },
    detailedInfo: { type: [Array, String], default: () => [] },
    expandable: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
  },
  computed: {
    hasDetails() {
      return Array.isArray(this.detailedInfo)
        ? this.detailedInfo.length > 0
        : !!this.detailedInfo;
    },
  },
  methods: { onToggle() { this.$emit('toggle', this.value); } },
};
</script>

<style scoped>
.checkbox-item {
  display: grid;
  grid-template-columns: 44px 1fr auto;
  grid-template-rows: auto auto;
  grid-template-areas:
    "left center right"
    "info info info";
  gap: 0 12px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e8f5f3;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(32,120,104,.06);
  transition: border-color .2s, box-shadow .2s;
  cursor: pointer;
}

.left {
  grid-area: left;
  position: relative;
  height: 32px;
}

.center {
  grid-area: center;
  display: flex;
  align-items: center;
}

.right {
  grid-area: right;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.info-row {
  grid-area: info;
  margin-top: 16px;
}

.native-checkbox { position: absolute; opacity: 0; pointer-events: none; }
.fake-box {
  width: 28px; height: 28px; display: inline-block;
  border: 2px solid #2a9d8f; border-radius: 10px; opacity: .5; background: #fff; position: relative;
}
.fake-box.checked { opacity: 1; background: #2a9d8f; border-color: #2a9d8f; box-shadow: 0 6px 16px rgba(32,120,104,.25); }
.fake-box.checked::after {
  content: ""; position: absolute; top: 5px; left: 8px; width: 8px; height: 14px;
  border: solid #fff; border-width: 0 3px 3px 0; transform: rotate(45deg);
}

.center { display: flex; align-items: center; }
.center .label { font-size: 16px; font-weight: 500; color: #000; }

.right { display: inline-flex; align-items: center; gap: 10px; }
.right-display { color: #207868; font-weight: 600; white-space: nowrap; }

/* caret button */
.info-toggle {
  width: 28px; height: 28px; border-radius: 50%;
  border: 1px solid #cfe8e3; background: #f2fbf8;
  display: inline-flex; align-items: center; justify-content: center; padding: 0;
}
.info-toggle:focus { outline: none; }
.caret {
  width: 0; height: 0; display: inline-block;
  border-left: 6px solid transparent; border-right: 6px solid transparent;
  border-top: 9px solid #207868; transition: transform .2s;
}
.caret.open { transform: rotate(180deg); }

/* info box */
.info {
  border-radius: 10px;
  background: #fff7df;
  border: 1px solid #f3e2b8;
  padding: 14px 16px;
  color: #666;
  width: 100%;
}
.info-title { font-weight: 700; margin-bottom: 6px; }
.info-list { margin: 0; padding-left: 18px; }
</style>
